<template>
  <div>
    <div class="scheduled text-left border-radius-8">
      <div class="icon">
        <img width="40" src="~assets/images/pickup.svg" />
      </div>
      <div class="text">
        <div class="scheduled-title">{{ $t('result.timePickup') }}</div>
        <div class="scheduled-times">{{ startTime }}-{{ endTime }}</div>
      </div>
    </div>
    <slot name="DragVerify" />
  </div>
</template>

<script>
export default {
  props: {
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.scheduled {
  background: #f3f4f6;
  padding: 16px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  .icon {
    font-size: 0;
    width: 40px;
    margin-right: 13px;
  }
  .text {
    flex: 1;
  }
  &-title {
    font-size: 14px;
    line-height: 120%;
  }
  &-times {
    font-weight: bold;
    font-size: 16px;
    line-height: 120%;
  }
}
</style>
